module.exports = __webpack_public_path__ + "static/img/9-4.d2b56896.jpg";